import React, {PropsWithChildren} from "react";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import {FormHelperText,} from '@material-ui/core';
import {FieldProps, getIn} from "formik";
import {useTranslation} from "react-i18next";

type ComboboxSelectProps = {
    caption: string,
    readOnly?: boolean,
    required?: boolean
}

const ComboboxWithErrorMessage: React.FC<PropsWithChildren<FieldProps & ComboboxSelectProps>> = ({field, required, readOnly, caption, children, ...props}) => {
    const {t} = useTranslation();

    const errorText = getIn(props.form.errors, field.name);

    return <FormControl margin="normal" required={!!required} fullWidth error={!!errorText} {...props}>
        <InputLabel htmlFor={caption}>{t(caption)}</InputLabel>
        <Select
            native
            disabled={readOnly}
            value={field.value}
            onChange={event => {
                const {value} = event.target;
                props.form.setFieldValue(
                    field.name,
                    value
                );
            }}
            label={required ? t(caption) + " *" : t(caption)}
            name={field.name}
            inputProps={{
                id: caption,
            }}
        >
            {children}
        </Select>
        <FormHelperText>{t(errorText)}</FormHelperText>
    </FormControl>
};

export default ComboboxWithErrorMessage;